import { Component, OnInit, Input, Inject } from '@angular/core';
import * as moment from 'moment';
import { AuthService } from '../core/auth/auth.service';
import { SortDirection, SortEvent } from '@allianz/ng-aquila/table';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import { AppConfig } from '../../config/app.config';


@Component({
  selector: 'app-salesreport-weekly',
  templateUrl: './salesreport-weekly.component.html',
  styleUrls: ['./salesreport-weekly.component.css'],
  standalone: false
})
export class SalesreportWeeklyComponent {
  @Input() policyStartDate: moment.Moment;
  @Input() policyEndDate: moment.Moment;

  fileName: string;
  ReportData: any;
  exportdata: any = [];
  _apiUrl: string;
  clientId: number;
  userTypeId: number;
  userBaseTypeId: number;
  userId: number;

  /** sorting starts here */

  sortTable(sort: SortEvent) {
    this.ReportData = this.ReportData.sort((a, b) => {
      if (sort.active in a && sort.active in b) {
        return this.compare(a[sort.active], b[sort.active], sort.direction);
      }
      return 0;
    });
  }

  compare(
    a: number | string | Date,
    b: number | string | Date,
    direction: SortDirection) {

    return (a < b ? -1 : 1) * (direction === 'asc' ? 1 : -1);
  }
  /** sorting ends here */
  /**Pagination Start */
  count: number = 0;
  pageNumber: number = 1;
  pageSize: number = 10;
  searchTerm: any = "";
  prevPage() {
    this.pageNumber--;
    this.getReportData();
  }

  nextPage() {
    this.pageNumber++;
    this.getReportData();
  }

  goToPage(n: number) {
    this.pageNumber = n;
    this.getReportData();
  }
  /**Pagination end */

  constructor(private authService: AuthService,
    private appConfig: AppConfig,) {
    this._apiUrl = appConfig.baseUrl;
    this.clientId = parseInt(atob(localStorage.getItem("CLIENT_ID")));
    this.userBaseTypeId = parseInt(atob(localStorage.getItem("USER_BASE_TYPE_ID")))
    this.userTypeId = parseInt(atob(localStorage.getItem("USER_TYPE_ID")))
  }


  loadReport() {
    this.getReportData()
  }

  getReportData() {
    var startdate = this.policyStartDate == undefined ? "" : this.policyStartDate.format('LL');
    var enddate = this.policyEndDate == undefined ? "" : this.policyEndDate.format('LL');

    this.authService.getList(this._apiUrl + `/api/v1/Report/GetSalesWeekReportWithPaging?pageNumber=${this.pageNumber}&pageSize=${this.pageSize}&searchText=${this.searchTerm}&startDatepicker=${startdate}&endDatepicker=${enddate}`)
      .subscribe(response => {
        if (response) {
          this.ReportData = response.body;
          let pagingProp = JSON.parse(response.headers.get('X-Pagination'));
          this.count = pagingProp.TotalCount;
        }
      }, (error) => {

      });
  }
  exporttoexcel() {
    var startdate = this.policyStartDate == undefined ? "" : this.policyStartDate.format('LL');
    var enddate = this.policyEndDate == undefined ? "" : this.policyEndDate.format('LL');
    this.authService
      .getList(this._apiUrl + `/api/v1/Report/GetSalesWeekReport?startDatepicker=${startdate}&endDatepicker=${enddate}`)
      .subscribe(
        (response) => {
          if (response) {
            this.ReportData = response.body;
            this.fileName = "SalesWeeklyReport_" + new Date(Date.now()).toLocaleString().split(',')[0] + '.xlsx';

            /* json data is passed over here */
            var workbook = new ExcelJS.Workbook();
            var worksheet = workbook.addWorksheet('WorkshopReport');

            // Header Row 1: Main headers with merged weekday columns
            const headerRow1 = [
              'Zone', 'State', 'City', 'Dealer/WorkShop Code', 'Dealer/WorkShop Name', 'Payment Date',
              'Sunday', '', 'Monday', '', 'Tuesday', '', 'Wednesday', '', 'Thursday', '',
              'Friday', '', 'Saturday', '', 'Total', ''
            ];
            worksheet.addRow(headerRow1);

            // Header Row 2: Subheaders
            const headerRow2 = [
              '', '', '', '', '', '',
              '#Count', '#Amount', '#Count', '#Amount', '#Count', '#Amount',
              '#Count', '#Amount', '#Count', '#Amount', '#Count', '#Amount',
              '#Count', '#Amount', '#Count', '#Amount'
            ];
            worksheet.addRow(headerRow2);

            // Merge static headers (A-F)
            for (let i = 1; i <= 6; i++) {
              worksheet.mergeCells(1, i, 2, i);
            }

            // Merge weekday headers
            const weekdayMerges = [
              ['G', 'H'], ['I', 'J'], ['K', 'L'], ['M', 'N'], ['O', 'P'],
              ['Q', 'R'], ['S', 'T'], ['U', 'V']
            ];
            weekdayMerges.forEach(([start, end]) => {
              worksheet.mergeCells(`${start}1:${end}1`);
            });

            // Insert data starting from row 3
            this.exportdata.forEach(item => {
              worksheet.addRow([
                item.zone,
                item.state_Name,
                item.city_Name,
                item.dealerOrWorkshopCode,
                item.workshop_Name,
                item.paymentDate,

                item.sundayCount, item.sundayAmount,
                item.mondayCount, item.mondayAmount,
                item.tuesdayCount, item.tuesdayAmount,
                item.wednesdayCount, item.wednesdayAmount,
                item.thursdayCount, item.thursdayAmount,
                item.fridayCount, item.fridayAmount,
                item.saturdayCount, item.saturdayAmount,
                item.totalCount, item.totalAmount
              ]);
            });
            this.saveAsExcelFile(workbook, this.fileName);
          }
        },
        (error) => {

        }
      );
  }

  saveAsExcelFile(wb: any, fileName: string): void {
    wb.xlsx.writeBuffer().then((data) => {
      var blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var a = window.document.createElement('a');
      var downloadUrl = window.URL.createObjectURL(blob);
      a.href = downloadUrl;
      a.download = `${fileName}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(downloadUrl);
    });
  }

}
